import React, { ReactElement } from 'react';

import Row from '@amzn/meridian/row';

export function makeRows(rowSize: number, elements: ReactElement[]): ReactElement[] {
    const rows: ReactElement[][] = [];
    elements.forEach((elem, index) => {
        if (index % rowSize === 0) {
            rows.push([]);
        }

        rows[rows.length - 1].push(elem);
    });

    return rows.map((row, rowIndex) => (
        <Row key={rowIndex} widths={'fill'} alignmentVertical={'stretch'}>
            {row}
        </Row>
    ));
}
